import React from 'react';

import DocumentRetrievalModule from '../modules/DocumentRetrievalModule.js';
import AnalysisResultsModule from '../modules/AnalysisResultsModule.js';
import './Box.css';

const ProtocolAssessmentBox = ({user, reportId, isSmallScreen}) => {
    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            {/* <h1 className='box-title'>Protocol Assessment</h1> */}
            <h4></h4>
            <DocumentRetrievalModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>
            <AnalysisResultsModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>
        </div>
    );
};

export default ProtocolAssessmentBox;
